import { ArchivedDocument } from "./ArchivedDocument";

export type ModalDialogProperties = {
    openDialog: () => void;
    closeDialog: () => void;
    dialogOpen: boolean;
    content?: ArchivedDocument;
    message?: string;
};
